import React, { ReactElement, useContext, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { useTranslation } from 'react-i18next'

import MenuModal from './MenuModal'
import Button from '@components/Button/Button'
import './WithMenu.scss'

import burger from '@assets/images/nav/burger.png'
import { SurveyContext } from '@context/SurveyContext'
import { getCategory } from '@utils/categoryFlow'
import { resolveHomeSubTitle } from '@utils/homeSubTitle'

const MenuButton = (): ReactElement => {
  const { t, i18n } = useTranslation('MainMenu')
  const { survey } = useContext(SurveyContext)
  const subTitle = resolveHomeSubTitle(getCategory(survey), t('subTitle'), i18n.language)
  const [menu, setMenu] = useState(false)
  const handleOpen = (): void => setMenu(true)
  const handleClose = (): void => setMenu(false)

  // http://reactcommunity.org/react-transition-group/transition#Transition-prop-nodeRef
  const nodeRef = useRef(null)
  return (
    <Button icon={<img src={burger} />} subtext={subTitle} propClassName="Button-burger" onClick={handleOpen}>
      {t('burger.text')}

      <CSSTransition in={menu} out={!menu} nodeRef={nodeRef} timeout={0} classNames="" mountOnEnter unmountOnExit>
        <MenuModal ref={nodeRef} key="MainMenuModal" onClose={handleClose} />
      </CSSTransition>
    </Button>
  )
}
export default MenuButton
